import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/Auth/AuthContext";
import * as Yup from "yup";
import axiosApiSigninInstance from "../../hooks/axiosLogin";
import { useFormik } from "formik";
import { showErrorToast } from "../../Toster";
import axiosPrivate from "../../hooks/axiosPrivate";
import CartCountContext from "../../context/CartCount/CartCountContext";

const SignUp = () => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(AuthContext);
  const { cartCountCheck, setCartCountCheck, setCartCount } =
    useContext(CartCountContext);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [verificationOtp, setVerificationOtp] = useState("");
  const [tempUserId, setTempUserId] = useState(null);
  const [tempUserData, setTempUserData] = useState(null);

  const loginSchma = Yup.object({
    email: Yup.string()
      .email()
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        "Please enter a valid email address with a proper domain"
      )
      .required("Email is Required"),
    name: Yup.string().required("Name is Required"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .min(10, "Mobile number must be of 10 digits")
      .max(10, "Mobile number must be of 10 digits"),
    password: Yup.string().required(" Password is Required"),
  });

  const loginForm = {
    name: "",
    email: "",
    password: "",
    mobile: "",
  };

  const addToCart = async (userId, cartItems) => {
    await cartItems?.map(async (item, index) => {
      let object = {
        product_id: item?.product_id,
        variant_id: item?.variant_id,
        quantity: item?.quantity,
        user_id: userId,
      };

      await axiosPrivate
        .post("/carts/create", object)
        .then((res) => {
          localStorage.removeItem("cart_items");
        })
        .catch((error) => { });
    });

    setCartCountCheck(!cartCountCheck);
  };

  function restrictChar(event) {
    const numericValue = event.target.value.replace(/\D/g, "");
    setFieldValue(event.target.name, numericValue);
  }

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: loginForm,
    validationSchema: loginSchma,
    onSubmit: (data, values) => {
      axiosApiSigninInstance
        .post("register", data)
        .then((res) => {
          // Check for userId in various possible locations
          const userId = res.data?.userId || res.data?.user_id || res.data?.id || res.data?.data?.userId || res.data?.data?.id;

          if (userId) {
            setTempUserId(userId);
            setTempUserData(res.data);
            setShowOtpModal(true);
            showErrorToast("OTP sent to your email. Please verify.");
          } else {
            console.error("Signup failed: No User ID returned", res.data);
            showErrorToast("Signup failed: No User ID returned");
          }
        })
        .catch((err) => {
          console.error("Signup Error:", err);
          if (err?.status == 422) {
            showErrorToast(err?.response?.data?.errors?.[0]?.msg);
          } else {
            showErrorToast(err?.response?.data?.message || "Signup failed");
          }
        });
    },

  });

  useEffect(() => {
    if (user.token && user.role !== "client") {
      navigate("/admin", { replace: true });
    }
  }, [user]);

  const handleVerifyOtp = () => {
    if (!verificationOtp) {
      showErrorToast("Please enter OTP");
      return;
    }

    const payload = {
      userId: tempUserId,
      otp: verificationOtp,
    };

    axiosApiSigninInstance
      .post("verify-otp", payload)
      .then((res) => {
        // Use response data if available, otherwise fallback to tempUserData
        // Assuming verify-otp might return the full user object with token
        const finalUserData = res.data && res.data.token ? res.data : tempUserData;

        localStorage.setItem("userData", JSON.stringify(finalUserData));
        setUser(finalUserData);
        const cartItems = JSON.parse(localStorage.getItem("cart_items"));
        addToCart(finalUserData?.userId, cartItems);

        if (finalUserData.role === "client") {
          if (cartItems) {
            navigate("/checkout");
          } else {
            navigate("/urban-gardens");
          }
        } else {
          navigate("/admin");
        }
        setShowOtpModal(false);
      })
      .catch((err) => {
        showErrorToast(err?.response?.data?.message || "OTP Verification Failed");
      });
  };


  return (
    <Fragment>
      <div className="auth_left">
        <div className="card">
          <div className="text-center mb-3">
            <Link className="header-brand" to="/">
              <img
                src="./../assets/images/home/logo.webp"
                alt="test"
                loading="lazy"
              />
            </Link>
          </div>

          {!showOtpModal ? (
            <form onSubmit={handleSubmit}>
              <div className="card-body">
                <div className="mb-4">Create new account</div>
                <div className="form-group">
                  <label className="">
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="name"
                    id="name"
                  />

                  {touched.name && errors.name ? (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.name}
                    </div>
                  ) : null}
                </div>

                <div className="form-group">
                  <label className="">
                    Email address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    className="form-control"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Email"
                  />

                  {touched.email && errors.email ? (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.email}
                    </div>
                  ) : null}
                </div>

                <div className="form-group">
                  <label className="">
                    Mobile No. <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    id="mobile"
                    name="mobile"
                    type="text"
                    maxLength={10}
                    minLength={10}
                    className="form-control"
                    placeholder="Enter Mobile Number *"
                    onChange={(e) => restrictChar(e)}
                    onBlur={handleBlur}
                    value={values.mobile}
                  />
                  {touched.mobile && errors.mobile ? (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.mobile}
                    </div>
                  ) : null}
                </div>

                <div className="form-group">
                  <label className="">
                    Password <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="password"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="password"
                    value={values.password}
                    className="form-control"
                    placeholder="Password"
                  />

                  {touched.password && errors.password ? (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.password}
                    </div>
                  ) : null}
                </div>

                <div className="form-footer">
                  <button className="btn btn-block submit-button" type="submit">
                    Sign Up
                  </button>
                </div>
              </div>
              <div className="text-center text-muted">
                Already have account? <Link to="/auth/signin">Sign In</Link>
              </div>
            </form>
          ) : (
            <div className="card-body">
              <div className="mb-4">Verify OTP</div>
              <div className="form-group">
                <label>OTP sent to your email <span style={{ color: "red" }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={verificationOtp}
                  onChange={(e) => setVerificationOtp(e.target.value)}
                  placeholder="Enter OTP"
                />
              </div>
              <div className="form-footer">
                <button
                  type="button"
                  className="btn btn-block submit-button"
                  onClick={handleVerifyOtp}
                >
                  Verify & Login
                </button>
              </div>
              <div className="text-center text-muted mt-2">
                <button className="btn btn-link p-0" onClick={() => setShowOtpModal(false)}>Back to Signup</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>

  );
};

export default SignUp;
